import React from "react";
function Footer() {
  return (
      <footer className="fixed bottom-0 left-0 w-full py-2  dark:bg-dark-mode">
          <p className="text-xs text-center text-dark-content dark:text-light-content">
              Designed and Coded by{" "}
              <a  className="font-medium"
                  href="http://qdesspro.fr/"
                  target="_blank"
                  rel="noreferrer noopener">
                  <span className="text-gradient font-medium">Quentin Dessere</span>
              </a>
          </p>
      </footer>

  );
}
export default Footer;
